import React from "react";
import { Card, CardContent, Typography, Box, Chip } from "@mui/material";

/**
 * StatCard — Tarjeta reutilizable para métricas del Dashboard.
 *
 * Props:
 * - title (string): Título principal
 * - value (string|number): Valor destacado (centrado y grande)
 * - subtitle (string, optional): Texto secundario debajo
 * - chipLabel (string, optional): Etiqueta en la esquina superior derecha
 * - chipColor (string, optional): Color del chip (primary|success|info|warning|error|default)
 * - gradient (string, optional): Gradiente CSS (ej. "linear-gradient(...)")
 * - loading (bool): Si true, muestra "—"
 */
export default function StatCard({
  title,
  value,
  subtitle,
  chipLabel,
  chipColor = "default",
  gradient,
  loading = false,
}) {
  const baseSx = {
    height: "100%",
    ...(gradient
      ? { background: gradient, color: "white" }
      : { bgcolor: "background.paper", color: "text.primary" }),
  };

  return (
    <Card elevation={gradient ? 0 : 2} sx={baseSx}>
      <CardContent>
        {/* Header: título + chip */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1.5,
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{ opacity: gradient ? 0.9 : 0.7 }}
          >
            {title}
          </Typography>
          {chipLabel && (
            <Chip label={chipLabel} color={chipColor} size="small" />
          )}
        </Box>

        {/* Valor principal */}
        <Typography
          variant="h3"
          fontWeight="bold"
          sx={{ lineHeight: 1.1 }}
        >
          {loading ? "—" : value}
        </Typography>

        {/* Subtítulo */}
        {subtitle && (
          <Typography
            variant="body2"
            sx={{ mt: 1, opacity: gradient ? 0.95 : 0.7 }}
          >
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}